import NoMatch from '@App/pages/NoMatch/NoMatch';

const routes = [
  {
    name: 'Page Not Found',
    path: '*',
    element: <NoMatch />,
  },
];

export default routes;
